import { Contract, types } from "@jutro/contract/internal";
import { ServiceManager } from "@jutro/services/internal";
import { logDeprecationMessage } from "../utils/logDeprecationMessage";
export var MessageInterface = Contract.specify({
  getMessage: types.func
});
export function getMessageService() {
  var messageService = ServiceManager.getServiceByContract(MessageInterface);
  if (!messageService) throw new Error("No implementation of MessageInterface provided.");
  return logDeprecationMessage("getMessageService", "useTranslator or TranslatorProvider from @jutro/locale package"), messageService;
}
export function getMessageProp(messageKey, messageProps, messages) {
  return (null == messageProps ? void 0 : messageProps[messageKey]) || messages[messageKey];
}